import React from "react";
import { useHistory } from "react-router-dom";
import { Button, Flex, Text } from "@jsq/ds/core";
import { DocumentStatusLabel } from "../../documents/DocumentStatusLabel";
import { ProfileType } from "../types";
import {
  provideLegalName,
  getComplianceLabel,
  getRelationshipLabel,
  isCompleted,
} from "../utils";
import {
  nodeContentWrapper,
  leftContentWrapper,
  headerText,
  subHeaderContainer,
  subHeaderDivider,
  rightContentWrapper,
} from "./style_vanilla.css";

export const ProfileTreeCard: React.FC<{
  profileInfo: ProfileType;
  basePath: string;
}> = ({ profileInfo, basePath }) => {
  const history = useHistory();
  const header = provideLegalName(profileInfo);
  const relationship = profileInfo.parentRelationships?.map((pr) => pr.relationshipType);
  const complianceTypeLabel = getComplianceLabel(profileInfo.complianceObjectType);

  // Map relationship types to human-readable labels and filter out any undefined values
  const relationshipLabel = relationship
    ?.map((relation) => {
      const label = getRelationshipLabel(relation);
      return label;
    })
    .filter(Boolean);

  const subHeader =
    relationshipLabel?.length > 0
      ? [...relationshipLabel, complianceTypeLabel].filter(Boolean)
      : complianceTypeLabel
        ? [complianceTypeLabel]
        : [];

  const buttonText = isCompleted(profileInfo) ? "Edit" : "Start";
  const buttonVariant = isCompleted(profileInfo) ? "neutral" : "primary";

  return (
    <Flex className={nodeContentWrapper}>
      <Flex className={leftContentWrapper}>
        <Text
          variant="strong-lg"
          className={headerText}
          data-testid="card_header"
          title={header}
        >
          {header}
        </Text>

        <Flex className={subHeaderContainer} data-testid="subheader_container">
          {subHeader &&
            subHeader
              .filter((item): item is string => item !== undefined)
              .map((item, index) => (
                <React.Fragment key={`subheader-${index}`}>
                  {index > 0 && (
                    <Text
                      variant="secondary-sm"
                      className={subHeaderDivider}
                      data-testid="subheader_divider"
                    >
                      |
                    </Text>
                  )}
                  <Text variant="secondary-sm">{item}</Text>
                </React.Fragment>
              ))}
        </Flex>
      </Flex>
      <Flex className={rightContentWrapper}>
        <DocumentStatusLabel documentTypes={profileInfo.rulesEngine?.documentTypes} />
        <Button
          variant={buttonVariant}
          data-testid="profile_tree_card_button"
          onClick={() => {
            history.push(`${basePath}/overview/${profileInfo.id}`);
          }}
        >
          {buttonText}
        </Button>
      </Flex>
    </Flex>
  );
};
